mutation DeleteContents($ids: [ID!]!) {
  deleteContents(ids: $ids) {
    id
  }
}
